import { useTimePickerDefaultizedProps } from '@material-ui/lab/TimePicker/shared';
/* eslint-disable */
import { CommonPost, CommonGet } from '../../../helpers/HttpClient';

export default {
    ResetPassword,
    getUserByID
};

async function ResetPassword(data, userId) {
    const body = {
        userID: userId,
        newPassword: data.newPassword,
    }
    const response = await CommonPost('/api/Auth/ResetPassword', null, body);
    return response;
}

async function getUserByID(userID) {
    const response = await CommonGet('/api/User/getUserDetailsByID', 'userID=' + parseInt(userID));
    return response.data;
}